import './registerServiceWorker'

import './_shared.coffee'
import './vendor.js'
import './vendor.coffee'
import App from './App.vue'

// global.API_ENDPOINT = if process.env.NODE_ENV == 'production' then 'https://hmbee.ru/api' else 'http://localhost:3000/api'

if (!global.HM) { global.HM = {} }

HM.store = new Vuex.Store(require('./store.coffee')())

import router from './routes.js'
HM.router = router

Vue.use({
  install(VueConstructor, _options) {
    VueConstructor.prototype.HM = HM;
    return VueConstructor.prototype.hm_date = hm_date;
  }
});

import Radio from 'components/inside/elements/radio.vue'
Vue.component('hm_radio', Radio)

import Checkbox from 'components/inside/elements/checkbox.vue'
Vue.component('hm_checkbox', Checkbox)

import Tooltip from 'components/inside/pages/virtuals/form_tooltips.vue'
Vue.component('hm_tooltip', Tooltip)

const VueI18n = require('vue-i18n').default;
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: HM.locale,
  silentTranslationWarn: true,
  messages: require('./locale.coffee')
});
// missing: (locale, key, vm) -> log.danger('missing translation', locale, key, vm) if locale == 'en'

$(function() {
  let app = new Vue({
    el: '#app',
    store: HM.store,
    i18n,
    router: HM.router,

    render(h) { return h(App) }
  })

  if (HM.is_development) {
    let hook = window.__VUE_DEVTOOLS_GLOBAL_HOOK__ || {}
    hook.Vue = app.constructor
  }

});

